import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { englishIqHistoryItemSchema } from '../schemas';

const listEnglishIqHistoryV1DataSchema = z.object({
  items: z.array(englishIqHistoryItemSchema),
});

export type IListEnglishIqHistoryV1Data = z.infer<typeof listEnglishIqHistoryV1DataSchema>;

export const listEnglishIqHistoryV1ResponseSchema: z.ZodSchema<IAPI<IListEnglishIqHistoryV1Data>> =
  createApiResponseSchema(listEnglishIqHistoryV1DataSchema) as z.ZodSchema<
    IAPI<IListEnglishIqHistoryV1Data>
  >;

export type IListEnglishIqHistoryV1Response = IAPI<IListEnglishIqHistoryV1Data>;
